module.exports = __webpack_public_path__ + "img/ic_rewards-points.7a695449.svg";